import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Switch from 'react-switch';

import { withRouter } from 'react-router-dom';
import qs from 'qs';

import {
  getIcon,
  focusAfterTimeout,
  getOptionValueForSelect,
  talentProfiles,
  localizeToString,
} from './../../util';

import {
  getTalentProfiles
} from './../../util/data';

import {
  updatePublicProfile,
  getCurrentTimestamp,
} from './../../actions';

import {
  Localize,
  CountrySelect,
} from '../shared';

import Select from 'react-select';

class InitializeProfile extends Component {

  state = {
    formError: null,
    firstName: '',
    lastName: '',
    country: '',
    talentProfile: '',
    dataPreference: 'secured',
    syncingWithServer: false,
    currentPage: 1,
    changingLocalization: false,
    talentProfileFixed: false,
  }

  formIsValid(){
    const {
      firstName,
      lastName,
      country,
      talentProfile,
    } = this.state;

    return firstName !== '' && lastName !== '' && country !== '' && talentProfile !== '';
  }

  initializeProfileData(){

    if(!this.formIsValid()){

      this.setState({
        formError: 'Make sure all fields are filled out'
      });

      return;
    }

    const {
      firstName,
      lastName,
      country,
      talentProfile,
      dataPreference,
    } = this.state;

    this.setState({
      syncingWithServer: true
    });

    this.props.updatePublicProfile({
      firstName,
      lastName,
      country,
      talentProfile,
      dataPreference,
    });
  }

  handleSubmit(event){
    event.preventDefault();
  }

  updateField(fieldName, fieldValue){
    this.setState({
      [fieldName]: fieldValue,
      formError: false,
    });
  }

  componentDidMount(){
    focusAfterTimeout(this, 'firstNameInput');

    //setup static talent profile if in param
    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });

    const profileName = params.profile;

    if(profileName && this.props.assessmentConfig && this.props.assessmentConfig.profileNames && this.props.assessmentConfig.profileNames[profileName]){
      this.setState({
        talentProfileFixed: true,
        talentProfile: this.props.assessmentConfig.profileNames[profileName]
      });
    }
  }

  currentStepComplete(){
    const {
      currentPage,
      firstName,
      lastName,
      country,
      talentProfile,
      dataPreference,
    } = this.state;

    if(currentPage === 1){
      return  firstName &&
              firstName !== '' &&
              lastName &&
              lastName !== '' &&
              country &&
              country !== '' &&
              talentProfile &&
              talentProfile !== '';
    }
    else{
      return true;
    }
  }

  getBackButton(){
    const { currentPage } = this.state;

    if(currentPage > 1){
      return(
        <button
          onClick={() => { this.setState({ currentPage: currentPage - 1 }); }}
          className="button grey-outline back-button">
          <Localize id="btn_back">Back</Localize>
        </button>
      )
    }
    else{
      return null;
    }
  }

  getNextButton(){
    const { currentPage } = this.state;

    if(currentPage < 2){
      return(
        <button
          disabled={!this.currentStepComplete()}
          onClick={() => { this.setState({ currentPage: currentPage + 1 }); }}
          className="button primary full-width">
          <Localize id="btn_next">Next</Localize>
        </button>
      )
    }
    else{
      return (
        <button
          disabled={!this.currentStepComplete()}
          onClick={this.initializeProfileData.bind(this)}
          className="button primary">
          <Localize id="btn_complete_setup">Complete Setup</Localize>
        </button>
      )
    }
  }

  getTalentProfileOptions(){

    if(!this.props.assessmentConfig || !this.props.assessmentConfig.scoredProfiles){
      return [];
    }

    //get talent profiles enabled for organization
    const allTalentProfiles = getTalentProfiles();

    const scoredProfileIds = this.props.assessmentConfig.scoredProfiles;

    const enabledProfiles = _.filter(allTalentProfiles, profile => {
      return scoredProfileIds.indexOf(profile.id) > -1;
    });

    let talentProfiles = _.map(enabledProfiles, profile => {
      return {
        value: profile.id,
        label: <Localize id={`talent_profile_${profile.id}_label`}>{profile.label}</Localize>
      }
    });

    return talentProfiles;
  }

  renderFormPage(){

    const {
      currentPage,
      firstName,
      lastName,
      country,
      talentProfile,
      dataPreference,
      syncingWithServer,
      talentProfileFixed,
    } = this.state;

    const talentProfileOptions = this.getTalentProfileOptions();

    const localizations = {
      firstName: localizeToString(this.props.activeLocalization, `field_first_name`),
      lastName: localizeToString(this.props.activeLocalization, `field_last_name`),
      country: localizeToString(this.props.activeLocalization, `field_country`),
      select: localizeToString(this.props.activeLocalization, `txt_select_field_label`)
    }

    return (
      <React.Fragment>
        {currentPage === 1 &&
          <div className="form-group">
            <label htmlFor="velocity-first-name">{localizations.firstName}</label>
            <input ref={input => { this.firstNameInput = input; }} id="velocity-first-name" disabled={syncingWithServer} type="text" placeholder={localizations.firstName} value={firstName} onChange={(e) => { this.updateField('firstName', e.target.value); } } />
          </div>
        }
        {currentPage === 1 &&
          <div className="form-group">
            <label htmlFor="velocity-last-name">{localizations.lastName}</label>
            <input id="velocity-last-name" disabled={syncingWithServer} type="text" placeholder={localizations.lastName} value={lastName} onChange={(e) => { this.updateField('lastName', e.target.value); } } />
          </div>
        }

        {currentPage === 1 &&
          <div className="form-group">
            <label>{localizations.country}</label>
            <CountrySelect
              className="hello"
              placeholder={localizations.select}
              currentCountry={country}
              changeCountry={newCountry => { this.updateField('country', newCountry); }}
              />
          </div>
        }
        {currentPage === 1 && !talentProfileFixed &&
          <div className="form-group">
            <label>Talent Profile<br/><small>Select the profile that most closely describes your job role</small></label>
            <Select
              classNamePrefix={'react-select'}
              className={`react-select-container talent-profile-select`}
              value={getOptionValueForSelect(talentProfileOptions, talentProfile)}
              options={talentProfileOptions}
              onChange={(option) => { this.updateField('talentProfile', option.value); }}
            />
          </div>
        }

        {currentPage === 2 &&
          <div className="form-group">
            <label className="centered"><Localize id="txt_dataprivacy">Data Privacy</Localize></label>
            <div className="profile-privacy-preference">
              {/*<div
                onClick={() => { this.updateField('dataPreference', 'public'); }}
                className={`option ${dataPreference === 'public' ? 'selected' : ''}`}
              >
                {getIcon('recruit')}
                <h6>FIND ME OPPORTUNITIES</h6>
                <p>Allow partner companies to find your profile and contact you about employement opportunities</p>
              </div>*/}
              <div
                onClick={() => { this.updateField('dataPreference', 'secured'); }}
                className={`option ${dataPreference === 'secured' ? 'selected' : ''}`}
              >
                {getIcon('hidden-folder')}
                <h6><Localize id="txt_dataprivacy_option_keep_label">Keep My Data</Localize></h6>
                <p><Localize id="txt_dataprivacy_option_keep_description">Keep my assessment data linked to my account so I can access my results later.</Localize></p>
              </div>
              <div
                onClick={() => { this.updateField('dataPreference', 'anonomous'); }}
                className={`option ${dataPreference === 'anonomous' ? 'selected' : ''}`}
              >
                {getIcon('anonomyze')}
                <h6><Localize id="txt_dataprivacy_option_purge_label">Purge My Data</Localize></h6>
                <p><Localize id="txt_dataprivacy_option_purge_description">Permanently delete my account and anonomyze my assessment results after reviewed or 60 days after assessment completion, whichever comes first.</Localize></p>
                <p></p>
              </div>
            </div>
          </div>
        }

      </React.Fragment>
    )
  }

  render(){

    const {
      firstName,
      lastName,
      formError,
      syncingWithServer,
    } = this.state;

    return (
      <div className="page initialize-profile">
        <form className="velocity-form page-form" onSubmit={this.handleSubmit.bind(this)}>
          <h2><Localize id="txt_complete_setup">Complete Setup...</Localize></h2>

          {formError &&
            <div className="form-message error">{formError}</div>
          }
          {this.renderFormPage()}
          {this.getBackButton()}
          {this.getNextButton()}
        </form>
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
    appConfig: state.appConfig.data,
    activeLocalization: state.activeLocalization.data,
  }
}

export default withRouter(connect(mapStateToProps, {updatePublicProfile})(InitializeProfile));



// WEBPACK FOOTER //
// ./src/components/takeAssessment/initializeProfile.js